(function () {

  'use strict';

  /**
   * @author Ronald Nicolls
   * @class ute-ui.extras
   * @memberOf ute-ui
   */
  angular.module('ute.ui')

  /**
   * @class ute-ui.extras.uteTable
   */
    .directive('uteTable', ['$http', '$filter', 'ngTableParams', function ($http, $filter, ngTableParams) {

      return {
        restrict: 'EA',
        scope: {
          tableData: '=',
          footerData: '=',
          language: '@',
          itemsPerPage: '=',
          initialSort: '@',
          order: '@',
          tableTemplateFolder: '@'
        },
        transclude: true,
        templateUrl: function ($element, $attrs) {
          var templateFolder = $attrs.tableTemplateFolder || 'views/templates/table/';
          return templateFolder + $attrs.tableBodyTemplate + '.html';
        },
        link: function ($scope) {

          /**
           * @name updateTableData
           * @type {function}
           * @memberOf ute-ui.extras.uteTable
           * @description updates table with new data
           * @param tableData
           */
          var updateTableData = function (tableData) {

            if (angular.isDefined(tableData)) {

              $scope.tableParams = new ngTableParams({
                  page: 1,
                  count: $scope.itemsPerPage >= 0 ? $scope.itemsPerPage : 1000,
                  sorting: {}
                },
                {
                  counts: [],
                  total: tableData.length,
                  getData: function ($defer, params) {
                    var orderedData = params.sorting() ? $filter('orderBy')(tableData, params.orderBy()) : tableData;
                    $defer.resolve(orderedData.slice((params.page() - 1) * params.count(), params.page() * params.count()));
                  }
                });

              /**
               * Adds dynamic sorting param from attribute
               */
              var orderDirection = $scope.order || 'desc';
              $scope.tableParams.$params.sorting[$scope.initialSort] = orderDirection;

              /**
               * Adds dynamic table data update behaviour
               */
              //$scope.tableParams.count(tableData.length);
              $scope.tableParams.count($scope.itemsPerPage >= 0 ? $scope.itemsPerPage : 1000);
              $scope.tableParams.reload();

            }

          };

          $scope.$watch('tableData', updateTableData);

        }

      };
    }]);

})();
